import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 2v20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AlignCenterVertical";
const AlignCenterVertical = memo(themed(Icon));
export {
  AlignCenterVertical
};
//# sourceMappingURL=align-center-vertical.js.map
